import React from 'react'

export const ChatContext = React.createContext()

export default function ChatContextProvider({ value, children }) {
  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>
}
